var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex justify-content-between"},[_c('span',{staticClass:"text-muted d-block text-center text-sm-start d-sm-inline-block"},[_vm._v("المفوضية الوطنيةالعليا للإنتخابات / منظومة السفيرات ")])])])
}]

export { render, staticRenderFns }